import { render } from "./RecommendList.vue?vue&type=template&id=0f92e397&scoped=true"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"

import "./RecommendList.vue?vue&type=style&index=0&id=0f92e397&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f92e397"]])

export default __exports__